import orderBy from 'lodash/orderBy.js';
import type { Survey } from './types.ts';

export const SurveyTabTitle = (props: {
    survey: Survey;
}) => {
    const { survey } = props;
    const answers = survey.projects.flatMap(x => x.answers);
    const count = answers.length;
    const last = orderBy(answers, [x => x.endDate, x => x.startDate], ['desc', 'desc'])[0];
    return (
        <div className="d-flex flex-column">
            <div>
                <strong>{survey.metadata.name}</strong>
            </div>
            <small>
                Enkätkod: <strong>{survey.metadata.surveyCode}</strong>
            </small>
            {!!count && <small>{count} inskickade enkäter</small>}
            {!!last && <small>Senast inskickad: {last.endDate}</small>}
            {!last && <small>Ingen enkät inskickad</small>}
        </div>
    );
};
